export default "__VITE_ASSET__BhEQ0PDf__"